var copyText = function (textToCopy, $element) {
    if (!navigator.clipboard) {
        var textArea = $('<textarea></textarea>');
        textArea.val(textToCopy);
        $element.append(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            if (successful) {
                HNotifications.show({
                    title: $filter("translate")("Copied to clipboard."),
                    desc: '',
                    icon: "fa-check",
                    type: "success",
                    timeout: 3000
                });
            }
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        textArea.remove();
        return;
    }
    navigator.clipboard.writeText(textToCopy).then(function () {
        HNotifications.show({
            title: $filter("translate")("Copied to clipboard."),
            desc: '',
            icon: "fa-check",
            type: "success",
            timeout: 3000
        });
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
    });
};

(function () {

    angular.module('directives')
        .directive('copyToClipboard', [function () {
            return {
                restrict: 'A',
                scope: {
                    'copyToClipboard': '@',
                },
                link: function (scope, $element) {
                    $element.on('click', function () {
                        var textToCopy = scope.copyToClipboard;
                        copyText(textToCopy, $element);
                    });
                }
            };
        }]);
})();
